module.exports = __webpack_public_path__ + "img/coin.05fa7f46.png";